import { POSITION_MAIN_COLOR } from "Pages/AnalyzersV2/@constants"

// The main provider's / main site's series as the Rank Analyzer marks the main brand: the app blue and a thicker
// line (CU-869fmm949). The competitors keep their colour and the chart's default width (3).
export const MAIN_STROKE_WIDTH = 5

export const mainSeriesLook = (isMain) => (isMain ? { color: POSITION_MAIN_COLOR, strokes: { strokeWidth: MAIN_STROKE_WIDTH } } : {})
